import { DURATION_TYPE_VALUE } from "../_config";
// import { getExtraShortcut } from "./getExtraShortcut";
import { shortcutOptionDefualt } from "./shortcutOptionDefualt"

export const filterSaveDurationValue = (startOfTime: string, latestDate: string, seasonInfo: any, dispatch: any) => {
  const optionsDefault = shortcutOptionDefualt(startOfTime, latestDate, seasonInfo, dispatch);
  // const seasonDefault = getExtraShortcut(seasonInfo, dispatch);
  // const resultOptionsArr = {
  //   'date': [...(optionsDefault?.date), ...(seasonDefault?.date)],
  //   'week': [...(optionsDefault?.week), ...(seasonDefault?.week)],
  //   'month': [...(optionsDefault?.month), ...(seasonDefault?.month)],
  // }

  const resultOptions: any = {};
  [...(optionsDefault?.date), ...(optionsDefault?.week), ...(optionsDefault?.month)]?.forEach((item: any) => {
    resultOptions[item?.type] = {
      type: item?.timeType,
      value: item?.value,
      name:item?.name,
      nameCN:item?.nameCN
    }
  })
  const result = {
    ...DURATION_TYPE_VALUE,
    ...(resultOptions || {}),
  }

  return result
}